import axios from 'axios'
import config from '../config/dev.json'
import production from '../config/production.json'

const path = '/api/contact'
let url

if (process.env.NODE_ENV === 'production') url = production.host + path
else url = config.host + path

url = 'http://102.219.178.151/backend/api/categories'

export function GetAllCategories() {
  return new Promise((resolve, reject) => {
    axios.get(url).then(response => {
      resolve(response.data)
    }).catch(err => resolve("echeck"))
  })
}

export function AddSubCategoryService(subcategory) {
    return new Promise((resolve, reject) => {
        axios.post(url +'/'+subcategory.categories[0]+'/sub-categories', subcategory).then(response => {
            resolve(response)
        }).catch(err => resolve("echeck"))
    }) 
}

export function UpdateSubCategoryService(subcategory) {
    return new Promise((resolve, reject) => {
        axios.put(url +'/'+subcategory.categories[0]+'/sub-categories/'+subcategory._id, subcategory).then(response => {
            resolve(response.data)
        }).catch(err => reject(err))
    }) 
}

export function DeleteSubCategoryService(subcategory) {
    return new Promise((resolve, reject) => {
        axios.delete(url +'/'+subcategory.categories[0]+'/sub-categories/'+subcategory._id).then(response => {
            resolve(response)
        }).catch(err => reject(err))
    }) 
}


